import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import DashboardLayout from "../../components/DashboardLayout/DashboardLayout";
import "./NeddieIntegrationPage.css";
// Width-based views (<=1194px => MobileView) so tablets get the same
// "continue on desktop" message as phones, not the cramped desktop layout.
import { BrowserView, MobileView } from '../../components/responsiveView';
import { Modal } from 'react-bootstrap';
import { useHistory } from "react-router-dom";

import Intigration from '../../images/img11.png';
// import Dmcard1 from '../../images/dmcard1.png';
// import Dmcard2 from '../../images/dmcard2.png';
// import Dmcard3 from '../../images/dmcard3.png';
import Dmcard4 from '../../images/img22.png';
// import Dmcard5 from '../../images/dmcard5.png';
// import Dmcard6 from '../../images/dmcard6.png';
// import { FaHeart } from "react-icons/fa";
import MobileTopBar from "../../components/common/MobileTopBar";
import IntegrationInfoCard from './IntegrationInfoCard';
import CustomizePageModal from './CustomizePageModal';
// import { FaCheck } from 'react-icons/fa';
export default function NeddieIntegrationPage() {
  const reduxOrg = useSelector((s: any) => s?.org);
  const orgId = reduxOrg?._id || "YOURORGID";
  const nickname = reduxOrg?.nickname || "yourorgnickname";
  const history = useHistory()
  // const [copied, setCopied] = useState(false);
  const [showCustomizeModal, setShowCustomizeModal] = useState(false);
  const [thankYouOnlyMode, setThankYouOnlyMode] = useState(false);
  const [showDesktopModal, setShowDesktopModal] = useState(true);
  const [accessAllowed, setAccessAllowed] = useState<boolean>(false);
  const [optionAComplete, setOptionAComplete] = useState<boolean>(false);

  const handleCustomizeSave = (data: any) => {
    console.log('Customize page data:', data);
    // `data` is the saved branding doc from the API — update gating state
    // immediately so the "Request Access" button appears without a page refresh.
    if (data && typeof data === 'object' && 'allowedEmbedDomains' in data) {
      setAccessAllowed(!!data.allowAccess);
      setOptionAComplete(Array.isArray(data.allowedEmbedDomains) && data.allowedEmbedDomains.length > 0);
    }
    loadBranding();
  };
  console.log( reduxOrg , 'reduxOrg' )
  // src="${window.location.origin}/embed/donate/${orgId}/${reduxOrg.campaigns[0]}"

  const embedCode = useMemo(
    () =>
      `<div style="width:100%;max-width:100%;box-sizing:border-box;">
        <iframe id="neddie-donation-embed-${orgId}"
          src="${window.location.origin}/embed/donate/${orgId}/default"
          style="width:100%;max-width:100%;min-width:0;box-sizing:border-box;border:0;display:block;margin:0 auto;height:auto;"
          title="${reduxOrg?.name || 'NEDDIE Donation Form'}"
          allow="payment"
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation-by-user-activation">
        </iframe>
        <script>
        (function(){
          var iframe = document.getElementById('neddie-donation-embed-${orgId}');
          if(!iframe) return;
          iframe.style.height = 'auto';
          function requestHeight(){
            try{ if(iframe.contentWindow) iframe.contentWindow.postMessage({ type: 'NEDDIE_REQUEST_HEIGHT' }, '*'); }catch(e){}
          }
          iframe.addEventListener && iframe.addEventListener('load', requestHeight);
          setTimeout(requestHeight, 250);
          window.addEventListener('message', function(event){
            if(event.data && event.data.type === 'NEDDIE_EMBED_RESIZE'){
              iframe.style.height = event.data.height + 'px';
            }

            // NEW: Logic to handle Stripe Modal
    if(event.data && event.data.type === 'NEDDIE_STRIPE_MODAL_STATE'){
      if(event.data.isOpen){
        iframe.dataset.isMaximized = 'true';
        iframe.style.position = 'fixed';
        iframe.style.top = '0';
        iframe.style.left = '0';
        iframe.style.width = '100vw';
        iframe.style.height = '100vh';
        iframe.style.zIndex = '999999';
        iframe.style.background = 'white'; // Prevent seeing the page behind it
      } else {
        iframe.dataset.isMaximized = '';
        iframe.style.position = 'static';
        iframe.style.width = '100%';
        iframe.style.height = 'auto';
        // Trigger a height request to snap back to normal
        if(iframe.contentWindow) iframe.contentWindow.postMessage({ type: 'NEDDIE_REQUEST_HEIGHT' }, '*');
      }
    }
          });
          window.addEventListener('resize', requestHeight);
        })();
        </script>
      </div>`
    ,
    [orgId, reduxOrg?.name]
  );

  const loadBranding = async () => {
    if (!orgId || orgId === 'YOURORGID') return;
    try {
      const res = await fetch(`/api/branding/by-org/${orgId}`, { cache: 'no-store' });
      if (!res.ok) {
        // No branding doc yet (404) or a request error — nothing is granted by default.
        setAccessAllowed(false);
        setOptionAComplete(false);
        return;
      }
      const json = await res.json();
      const data = json?.data;
      setAccessAllowed(!!data?.allowAccess);
      // Option A form is "filled out" once the branding doc exists and has at
      // least one allowed embed domain (the required field in that modal).
      setOptionAComplete(Array.isArray(data?.allowedEmbedDomains) && data.allowedEmbedDomains.length > 0);
    } catch (e) {
      setAccessAllowed(false);
      setOptionAComplete(false);
    }
  };

  useEffect(() => {
    loadBranding();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgId]);



  // const handleCopy = async () => {
  //   try {
  //     await navigator.clipboard.writeText(embedCode);
  //     setCopied(true);
  //     setTimeout(() => setCopied(false), 1600);
  //   } catch {}
  // };




  return (
    <>
      <BrowserView>
        <DashboardLayout>
          <section className="ni-wrap">
            {/* LEFT: copy + code box */}
            <div className="ni-left">
              <div className="row">
                <div className="col">
                  <h1 className="ni-title">Add NEDDIE Checkout Box to Your Website</h1>
                  <p className="ni-sub">
                    Give donors the best experience to support your cause, with
                    multiple payment options, recurring donations, and a seamless
                    checkout process.&nbsp;
                    <strong>
                      To offer all payment options in your checkout box, make sure to connect both Stripe and PayPal under “Connect Payments”
                    </strong>
                  </p>
                </div>
                {/* <div className="col-lg-6">
                  <p className="ni-note">
                    <strong>
                      To activate your checkout box, please connect your bank account
                      under “Connect Payments.”
                    </strong>
                  </p>
                  <p className="ni-sub ni-sub--spaced">
                    Adding the checkout box is simple. Copy the code below and paste it
                    into your website.
                  </p>
                </div> */}

              </div>


              {/* Code box */}
              {/* <div className="ni-codebox">
            <div className="ni-codebox-top">
              <span className={`ni-copied ${copied ? "is-on" : ""}`}>
                ✓ Copied
              </span>
              <button className="ni-copy-btn" onClick={handleCopy}>
                <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
                  <path
                    d="M9 3h9a2 2 0 0 1 2 2v11h-2V5H9V3ZM4 7h9a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2Zm0 2v11h9V9H4Z"
                    fill="currentColor"
                  />
                </svg>
                Copy code
              </button>
            </div>
            <pre className="ni-pre">{embedCode}</pre>
          </div> */}




            </div>

            {/* RIGHT: preview browser with nav → (hero | widget) two-column */}
            {/* <div className="ni-right">
          
          <div className="ni-browser">
            <div className="ni-browser-bar"><span/><span/><span/></div>

            <div className="ni-nav">
              <div className="ni-brand">
                <div className="ni-brand-mark" />
                <div className="ni-brand-name">Bright Futures<br/>Foundation</div>
              </div>
              <div className="ni-nav-items">
                <span>About</span>
                <span>Programs</span>
                <span>Volunteer</span>
                <span>Resources</span>
                <span>Contact Us</span>
                <button className="ni-donate-pill">Donate</button>
              </div>
            </div>

            <div className="ni-content">
              <div className="ni-hero">
                <h2>Bright Futures Foundation</h2>
                <p className="ni-hero-sub">
                  At Bright Futures Foundation, we believe every child deserves
                  the opportunity to learn, dream, and thrive.
                </p>

                <div className="ni-photo-frame">
                  <img
                    className="ni-photo-img"
                    alt="Child painting"
                    src={Intigration}
                  />
                </div>

                <p className="ni-hero-p">
                  Your donation is more than a gift—it’s a lifeline. Every
                  dollar you give helps provide children with access to quality
                  education, nutritious meals, and the mentorship they need to
                  thrive. With your support, we can open doors to brighter
                  opportunities, break cycles of poverty, and empower the next
                  generation to dream without limits. Together, we are building
                  futures filled with hope and possibility.
                </p>
              </div>

              <aside className="ni-widget">
                <div className="ni-widget-head">Your gift will make a difference</div>

                <div className="ni-widget-label">I would like to give</div>
                <div className="ni-toggle">
                  <label className="is-on">
                    <FaHeart style={{color:"#50f4a5"}}/>  One-time
                  </label>
                  <label>
                    <FaHeart style={{color:"#e3e0e3"}}/> Monthly
                  </label>
                  <label>
                    <FaHeart style={{color:"#e3e0e3"}}/> Annually
                  </label>
                </div>

                <div className="ni-amounts">
                  <button>$25</button><button>$50</button>
                  <button>$100</button><button>$200</button>
                </div>

                <div className="ni-field">
                  <label>Other Amount</label>
                  <div className="ni-input"><span>$</span><input defaultValue=""/></div>
                </div>

                <div className="ni-field">
                  <label>Donate With</label>
                      
                                  
                  <div className="">
                    <div className="row">
    <div className="col-4">
     <img style={{width:"90px"}} src={Dmcard1} alt="" />
    </div>
    <div className="col-4">
       <img style={{width:"90px"}} src={Dmcard2} alt="" />
    </div>
    <div className="col-4">
     <img style={{width:"90px"}} src={Dmcard3} alt="" />
    </div>
    
  </div>
  <div className="row">
     <div className="col-4">
      <img style={{width:"90px"}} src={Dmcard4} alt="" />
    </div>
    <div className="col-4">
       <img style={{width:"90px"}} src={Dmcard5} alt="" />
    </div>
    <div className="col-4">
      <img style={{width:"90px"}} src={Dmcard6} alt="" />
    </div>
  </div>
 
         </div>
                </div>

                <div className="ni-field">
                  <label>Email</label>
                  <div className="ni-input"><input defaultValue="john@example.com"/></div>
                </div>
                <div className="ni-field">
                  <label>Card Information</label>
                  <div className="ni-input"><input defaultValue="4242 4242 4242 4242  •  12/28  •  123"/></div>
                </div>
                <div className="ni-field">
                  <label>Name on card</label>
                  <div className="ni-input"><input defaultValue="John Doe"/></div>
                </div>

                <button className="ni-cta">Give Monthly. Change Lives.</button>

                <div className="ni-checks">
                  <label><input type="checkbox" defaultChecked/> Please share my name and demographic with Coco Puerto Rico.</label>
                  <label><input type="checkbox" /> I’ll cover the $0.75 processing fee.</label>
                </div>

                <button className="ni-donate">Donate</button>

                <div className="ni-safe">
                  <div className="ni-lock" /> We protect your donation
                  <div className="ni-badges"><b>visa</b><b>mc</b><b>stripe</b></div>
                </div>

                <div className="ni-powered">Powered by <b>NEDDIE</b></div>
                <div className="ni-terms">
                  By clicking donate you agree to donate amount shown. <u>Terms</u> and <u>Privacy</u>.
                </div>
              </aside>
            </div>
          </div>
        </div> */}
            <h1 className="ni-title mx-auto">Integration Options</h1>

            {/* Extra info cards row - keeps existing design intact */}
            <div className="ni-extra-cards" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(300px,1fr))', gap: '22px',/*marginTop:'28px'*/ }}>
              <IntegrationInfoCard
                imageSrc={Intigration}
                title="Option A — Add the NEDDIE Checkout Box to Your Website"
                description={<div>
                  <p style={{ fontWeight: "bold" }}>Seamlessly connect NEDDIE's donation checkout to your website.</p>
                  <p style={{ marginTop: '10px' }}>With just a few lines of API code (developer required), you can embed NEDDIE's powerful checkout box directly on your site and unlock:</p>
                  <ul style={{ paddingLeft: '20px', margin: '10px 0' }}>
                    <li style={{ marginBottom: '8px' }}><strong>Multiple Payment Options</strong> — Accept Credit/Debit Cards, ACH/Bank Transfers, PayPal, Venmo, Google Pay, Apple Pay, and Recurring Donations.</li>
                    <li style={{ marginBottom: '8px' }}><strong>Advanced Dashboard</strong> — Track every transaction, download reports, and view donor details like name, email, and location.</li>
                    <li style={{ marginBottom: '8px' }}><strong>Donor Engagement Tools</strong> — Send emails, receive instant donation alerts, and customize your thank-you page — all within your dashboard.</li>
                    <li style={{ marginBottom: '8px' }}><strong>Future-Ready</strong> — Automatically eligible for new payment options like Donor-Advised Funds and upcoming NEDDIE features.</li>
                  </ul>
                  <p style={{ fontWeight: "bold", marginTop: '15px' }}>Empower your fundraising.</p>
                  <p>Connect your NEDDIE Checkout API and start building stronger relationships with your donors today.</p>

                  <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #e9ecef' }}>
                    <p style={{ fontWeight: "bold", color: '#495057', marginBottom: '8px' }}>Follow These Steps to Set It Up:</p>
                    <p style={{ color: '#6c757d', marginBottom: '12px' }}>Paste the code on your website</p>
                    <ol style={{ paddingLeft: '20px', margin: '0', color: '#495057' }}>
                      <li style={{ marginBottom: '8px' }}>Go to your website editor (like WordPress, Wix, or Squarespace).</li>
                      <li style={{ marginBottom: '8px' }}>Open the page where you want the NEDDIE donation box to appear, for example, your "Donate" page.</li>
                      <li style={{ marginBottom: '8px' }}>Add a new HTML block or code section, and paste the NEDDIE code provided in your dashboard.</li>
                      <li style={{ marginBottom: '8px' }}>Don't forget to <button onClick={() => { setThankYouOnlyMode(true); setShowCustomizeModal(true); }} style={{ color: '#3b82f6', textDecoration: 'underline', background: 'none', border: 'none', cursor: 'pointer', padding: 0, font: 'inherit' }}>customize your thank you note</button>.</li>
                    </ol>
                  </div>
                </div>}
                copyContent={`${embedCode}`}
                orgID={orgId}
                orgName={reduxOrg?.name}
                accessAllowed={accessAllowed}
                optionAComplete={optionAComplete}
                onCustomizeOptionA={() => { setThankYouOnlyMode(true); setShowCustomizeModal(true); }}
                disable={false}
              />

              <IntegrationInfoCard
                imageSrc={Dmcard4}
                title="Option B — Customize Your Donate Page with NEDDIE and Connect It to Your Website"
                description={
                  <div>
                    <p style={{ fontWeight: "bold" }}>Add powerful giving tools to your website - no coding required.</p>
                    <p style={{ marginTop: '10px' }}>Easily connect NEDDIE's donation checkout to your site using a simple URL link - <strong>no developer needed</strong>.</p>
                    <ul style={{ paddingLeft: '20px', margin: '10px 0' }}>
                      <li style={{ marginBottom: '8px' }}><strong>Multiple Payment Options</strong> - Accept Credit/Debit Cards, ACH/Bank Transfers, PayPal, Venmo, Google Pay, Apple Pay, and Recurring Donations.</li>
                      <li style={{ marginBottom: '8px' }}><strong>Advanced Dashboard</strong> - Track every transaction, view donor details, download reports, and manage everything in one place.</li>
                      <li style={{ marginBottom: '8px' }}><strong>Donor Engagement Tools</strong> - Send emails, receive instant donation alerts, and customize your thank-you page.</li>
                      <li style={{ marginBottom: '8px' }}><strong>Future-Ready</strong> - Automatically eligible for new payment methods like Donor-Advised Funds and more.</li>
                    </ul>
                    <p>Turn your website into a complete fundraising hub in minutes - with NEDDIE Checkout.</p>

                    <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #e9ecef' }}>
                      <p style={{ fontWeight: "bold", color: '#495057', marginBottom: '8px' }}>Follow These Steps to Set It Up:</p>
                      <p style={{ color: '#6c757d', marginBottom: '12px' }}>Paste the code on your website</p>
                      <ol style={{ paddingLeft: '20px', margin: '0', color: '#495057' }}>
                        <li style={{ marginBottom: '8px' }}>Go to your "Donate" button or page.</li>
                        <li style={{ marginBottom: '8px' }}>Paste your NEDDIE link as the button's URL or hyperlink.</li>
                        <li style={{ marginBottom: '8px' }}>Don't forget to <button onClick={() => { setThankYouOnlyMode(false); setShowCustomizeModal(true); }} style={{ color: '#3b82f6', textDecoration: 'underline', background: 'none', border: 'none', cursor: 'pointer', padding: 0, font: 'inherit' }}>customize your page</button>.</li>
                      </ol>
                      <p className="mt-4" style={{ marginBottom: '8px', fontWeight: 700, fontSize: '12px' }}>Please note: You need to create and customize your URL nickname in your <button onClick={()=>history.push(`/nonprofit/${reduxOrg._id}`)} style={{ color: '#3b82f6', textDecoration: 'underline', background: 'none', border: 'none', cursor: 'pointer', padding: 0, font: 'inherit' }}>NEDDIE profile</button>  to activate your link.</p>
                    </div>
                  </div>}
                copyContent={`${window.location.origin}/give/${nickname}`}
                disable={false}
              />
            </div>
          </section>
        </DashboardLayout>



        {/* Customize Page Modal */}
        <CustomizePageModal
          show={showCustomizeModal}
          onHide={() => {
            setShowCustomizeModal(false);
            setThankYouOnlyMode(false);
            loadBranding();
          }}
          onSave={handleCustomizeSave}
          orgID={orgId}
          thankYouOnly={thankYouOnlyMode}
        />
      </BrowserView>
      <MobileView>
        <Modal centered show={showDesktopModal} onHide={() => setShowDesktopModal(false)} className='mobile-integration-desktop-modal'>
          <span onClick={() => { setShowDesktopModal(false) }} className='mobile-integration-modal-cross'>X</span>
          <p>To integrate your NEDDIE Checkout Box, please continue on desktop.</p>
        </Modal>
        <div className="mobile-integration-page">
          <MobileTopBar />

          <div className="mobile-integration-content">
            {/* Main Hero Section */}
            <section className="mobile-integration-hero">
              <h1 className="mobile-integration-title">
                Offer Your Donors<br />
                More Ways To Give
              </h1>

              <div className="mobile-donate-section">
                <img style={{ width: "100%", borderRadius: "9px" }} src="/mobile-icon/Screenshot_7.svg" alt="donaton" />


              </div>
            </section>

            {/* Integration Info Section */}
            <section className="mobile-integration-info">
              <h2 className="mobile-section-title">
                Add NEDDIE Checkout Box<br />
                to Your Website
              </h2>
              <p className="mobile-section-subtitle">
                Give donors the best experience to support your cause, with multiple
                payment options, recurring donations, and a seamless checkout process.
              </p>
              <div className="mobile-why-section">
                <h3 className="mobile-why-title">Why Use NEDDIE Integration?</h3>
                <p className="mobile-why-intro font-weight-bold">
                  Seamlessly connect NEDDIE's donation checkout to your website.
                </p>
                <p className="mobile-why-description">
                  With just a few lines of API code (developer required), you can embed NEDDIE's powerful checkout box directly on your site and unlock:
                </p>
                <ul className="mobile-why-features">
                  <li>
                    <strong>Multiple Payment Options-</strong> Accept Credit/Debit Cards, ACH/Bank Transfers, PayPal, Venmo, Google Pay, Apple Pay, and Recurring Donations.
                  </li>
                  <li>
                    <strong>Advanced Dashboard-</strong> Track every transaction, download reports, and view donor details like name, email, and location.
                  </li>
                  <li>
                    <strong>Donor Engagement Tools-</strong> Send emails, receive instant donation alerts, and customize your thank-you page — all within your dashboard.
                  </li>
                  <li>
                    <strong>Future-Ready-</strong> Automatically eligible for new payment options like Donor-Advised Funds and upcoming NEDDIE features.
                  </li>
                  <li>
                    <strong>Empower your fundraising-</strong> Connect your NEDDIE Checkout API and start building stronger relationships with your donors today.
                  </li>
                </ul>
                <img src="/mobile-icon/Screenshot_1.png" style={{width:"100%", marginTop: "20px"}} alt="donation" />

              </div>
              <div className="how-it-works mt-5">
                <h3 className="mobile-why-title">Why Use NEDDIE Integration?</h3>
                <p className="mobile-why-description">
                  Give donors the best experience to support your cause, with multiple payment options, recurring donations, and a seamless checkout process.
                </p>
                <p className="mobile-why-description">
                  To activate your checkout box, please connect your bank account under “Connect Payments.”
                </p>
                <p className="mobile-why-description">
                  To set up your CheckoutBox, please continue on desktop.
                </p>
              </div>

              {/* <div className="mobile-code-section">
                <p className="mobile-code-instructions">
                  Adding the checkout box is simple. Copy the code below and paste it
                  into your website.
                </p>
              </div> */}


              {/* <div className="mobile-code-section">
              <p className="mobile-code-instructions">
                Adding the checkout box is simple. Copy the code below and paste it
                into your website.
              </p>

              <div className="mobile-code-box">
                <div className="mobile-code-header">
                  <button className="mobile-copy-button" onClick={handleCopy}>
                    <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
                      <path
                        d="M9 3h9a2 2 0 0 1 2 2v11h-2V5H9V3ZM4 7h9a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2Zm0 2v11h9V9H4Z"
                        fill="currentColor"
                      />
                    </svg>
                    {copied ? '✓ Copied' : 'Copy code'}
                  </button>
                </div>
                <pre className="mobile-code-content">{embedCode}</pre>
              </div>
            </div> */}


            </section>
          </div>
        </div>
      </MobileView>

      {/* Customize Page Modal */}
      <CustomizePageModal
        show={showCustomizeModal}
        onHide={() => {
          setShowCustomizeModal(false);
          setThankYouOnlyMode(false);
        }}
        onSave={handleCustomizeSave}
        orgID={orgId}
        thankYouOnly={thankYouOnlyMode}
      />
    </>
  );
}
